"use client";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { EDITOR_INITIAL_STATE } from "components/editor/Editor";
import { $getRoot } from "lexical";
import { useEffect } from "react";

interface ResetEditorPluginProps {
  initialState?: string;
}

export default function ResetEditorPlugin({ initialState }: ResetEditorPluginProps) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (initialState === EDITOR_INITIAL_STATE) {
      editor.update(() => {
        $getRoot().clear();
      });
    }
  }, [initialState, editor]);

  return null;
}
